class ImageSliderComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == 'true') {
      this.settings = {
        autorotate: this.dataset.autorotate == 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
        cellAlign: this.dataset.cellAlign

      };
      this.slider = this.querySelector('.image-carousel__list');

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0
      });
    }
  }

  init() {
    setTimeout(() => {
      if (this.slider) {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: true,
          arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
          pageDots: false,
          wrapAround: true,
          draggable: true,
          cellAlign: this.settings.cellAlign ? this.settings.cellAlign : 'center',
          autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
          pauseAutoPlayOnHover: true,
          asNavFor: this.previews
        });
      }

      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity && this.flickity.on('staticClick', (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == 'number') {
          this.flickityNav.select(cellIndex);
        }
      });

      // ✅ 初始化后高亮并激活当前 item
      this.activateCurrentItem();
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity) {
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  activateCurrentItem() {
    if (!this.flickity) return;

    const currentUrl = window.location.href.split('?')[0].replace(/\/$/, '');
    const links = this.querySelectorAll('a.full-unstyled-link');

    links.forEach((link, index) => {
      const linkUrl = link.href.split('?')[0].replace(/\/$/, '');
      if (linkUrl === currentUrl) {
        const item = link.closest('.carousel__item') || link.parentElement;

        if (item) {
          item.classList.add('is-active');

          // ✅ 让 Flickity 跳转到对应 slide
          this.flickity.select(index, false, true);
        }
      }
    });
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }
}

customElements.define('image-slider-component', ImageSliderComponent);
